<template>
  <section>
    <v-container fluid>
      <v-row class="justify-end align-center">
        <!-- <v-col cols="auto">
          <v-row no-gutters>
            <v-chip-group mandatory v-model="statusFilter" active-class="success">
              <span class="caption my-auto">Filtrar:</span>
              <v-chip class="mx-1" label :value="1">
                Conectados
              </v-chip>

              <v-chip class="mx-1" label :value="0">
                Desconectados
              </v-chip>
            </v-chip-group>

            <v-btn
              height="32"
              class="ml-3 mt-2"
              depressed
              @click="reloadPage"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </v-row>
        </v-col> -->

        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1 mt-5 mt-md-10">
      <!-- NO TOCAR. ESTA PAGINACIÓN POR SERVIDOR SI FUNCIONA -->
      <v-data-table
        :search="search"
        :headers="headers"
        :items="agentInfo"
        item-key="id"
        :loading="isLoading"
        :options.sync="options"
        :expanded.sync="expanded"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar size="40" tile>
                <v-badge
                  :bordered="item.online"
                  bottom
                  :color="item.online ? 'success' : 'transparent'"
                  dot
                  offset-x="10"
                  offset-y="10"
                >
                  <v-avatar
                    size="40"
                    :color="
                      $vuetify.theme.dark ? 'blue-grey darken-4' : 'blue-grey lighten-5'
                    "
                  >
                    <v-img
                      v-if="item.url_image"
                      :src="item.url_image"
                      alt="Avatar del usuario"
                    ></v-img>
                    <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                  </v-avatar>
                </v-badge>
              </v-list-item-avatar>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.statusExtension`]="{ item }">
          <v-chip color="transparent" small>
            <!-- <v-icon left small :color="statusColor(item.status)"
              >mdi-radiobox-marked</v-icon
            > -->
            {{ extensionState(item.extension) }}
            <!-- {{ item.extension }} -->
          </v-chip>
        </template>

        <template v-slot:[`item.statusQueue`]="{ item }">
          <v-chip color="transparent" small>
            <v-icon
              left
              small
              :color="item.online !== null && item.connect === 1 ? 'success' : 'grey'"
              >mdi-radiobox-marked</v-icon
            >
            {{
              item.online !== null && item.connect === 1 ? "Conectado" : "Desconectado"
            }}
          </v-chip>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            v-if="item.status == 2"
            color="transparent"
            small
            @click.stop="openConfirmClose(item.user_pause[0].id)"
          >
            <v-icon left small :color="statusColor(item.status)"
              >mdi-radiobox-marked</v-icon
            >
            {{ item.status | StatusName }}
          </v-chip>

          <v-chip
            v-else-if="item.status == 3"
            color="transparent"
            small
            @click.stop="UnlockAgent(item.lock_user.id)"
          >
            <v-icon left small :color="statusColor(item.status)"
              >mdi-radiobox-marked</v-icon
            >
            {{ item.status | StatusName }}
          </v-chip>

          <v-chip v-else color="transparent" small>
            <v-icon left small :color="statusColor(item.status)"
              >mdi-radiobox-marked</v-icon
            >
            {{ item.status | StatusName }}
          </v-chip>
        </template>

        <template v-slot:[`item.extension`]="{ item }">
          <span :class="[item.extension === null ? 'text--secondary' : '']">{{
            item.extension !== null
              ? item.extension
              : item.extension_opcional
              ? item.extension_opcional
              : item.variable
          }}</span>
          <v-icon v-if="item.variable" small class="ml-1" color="grey">mdi-dice-3</v-icon>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="openRangeDialog(item.id, item.name)"
              >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </v-hover>

          <!-- <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="handleEdit(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover> -->

          <!-- <v-hover
            v-slot:default="{ hover }"
          >
            <v-tooltip color="blue-grey" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  text
                  icon
                  :color="hover ? 'error' : 'blue-grey'"
                  @click.stop="handleLogoutPlanta(item.id, item.name)"
                >
                  <v-icon>mdi-connection</v-icon>
                </v-btn>
              </template>
              <span>Desconectar de planta</span>
            </v-tooltip>
          </v-hover> -->

          <!-- <v-hover
            v-if="item.online !== null && item.connect === 0"
            v-slot:default="{ hover }"
          >
            <v-tooltip color="blue-grey" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  text
                  icon
                  :color="hover ? 'error' : 'blue-grey'"
                  @click.stop="handleLogoutSystem(item.id, item.name)"
                >
                  <v-icon>mdi-exit-to-app</v-icon>
                </v-btn>
              </template>
              <span>Cerrar sesión</span>
            </v-tooltip>
          </v-hover> -->
        </template>
      </v-data-table>
    </v-card>

    <!-- Componentes -->
     <!-- Modal de fecha -->
    <v-dialog v-model="rangeDialogActive" persistent scrollable max-width="500">
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card>
          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Seleccione fecha
              </v-card-title>
            </v-img>
          </v-card-title>
          <v-card-text style="max-height: 350px" class="pt-5">
            <v-form>
              <v-row dense justify="center">
                <v-col cols="12">
                  <regular-date-range-picker @dates:change="getRangeDates" />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="rangeDialogActive = false"
                >Cancelar</v-btn
              >
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="isLoading"
                :disabled="isLoading || date == ''"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="eventdialog('consultar')"
              >
                Consultar
              </v-btn>
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>

    <v-dialog v-model="timelineDialog" persistent scrollable max-width="800">
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card>
          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Historial de {{ agentSelectedName }}
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 800px">
              <v-timeline
              v-if="agentHistory.length > 0"
                align-top
                dense
              >
                <v-timeline-item class="pb-0"
                  v-for="item in agentHistory"
                  :key="item.id"
                  :fill-dot="!typeAction(item.action_type_id).small"
                  :small="typeAction(item.action_type_id).small"
                  :color="typeAction(item.action_type_id).color"
                  :icon="typeAction(item.action_type_id).icon"
                  >
                  <div class="d-flex">
                    <div>
                      <strong class="me-4">{{ item.created_at | dateFormat }}</strong>
                      <p>{{ item.created_at | getHourFormat }}</p>
                    </div>
                    <div>
                      <strong>{{ item.action.name }}</strong>
                      <div class="text-caption">
                        {{ item.action.description }}
                      </div>
                    </div>
                  </div>
                </v-timeline-item>
              </v-timeline>

              <p v-else>
                Sin actividad en el tiempo consultado.
              </p>

              <!-- {{ agentHistory }} -->
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="closedRangeDialog"
                >Cerrar</v-btn
              >
            </v-hover>

            <!-- <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="isLoading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="passes(downloadTodayCsv)"
              >
                Consultar
              </v-btn>
            </v-hover> -->
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </section>
</template>

<script>
import vuescroll from "vuescroll";
import axios from "axios";
import { PbxHttpClient } from "@/services/httpclient";
// import btnupdate from "@/components/Users/User/btnupdate.vue";
import { getTimeTillNow } from "@/components/Utils/timeHelpers";
import RegularDateRangePicker from "@/components/DatePickers/RegularDateRangePicker.vue";

export default {
  name: "AgentList",

  components: {
    // btnupdate,
    vuescroll,
    RegularDateRangePicker
  },

  data() {
    return {
      isLoading: false,
      rangeDialogActive: false,
      timelineDialog: false,
      statusFilter: 1,
      search: "",
      expanded: [],
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: -1,
      },
      // End for pagination
      agentInfo: [],
      newExtensionList: [],
      agentInfoBackup: [],
      active: false,
      editUser: {},
      headers: [
        {
          text: "Agente",
          align: "left",
          value: "name",
          class: "primary--text",
          width: "40%",
        },
        {
          text: "Extensión",
          value: "extension",
          class: "primary--text",
          width: "40%",
        },
        // {
        //   text: "Inicio jornada",
        //   value: "online_data.created_at",
        //   class: "primary--text",
        //   width: "15%",
        // },
        // {
        //   text: "Estado cola",
        //   value: "statusQueue",
        //   class: "primary--text",
        //   width: "10%",
        // },
        // {
        //   text: "Estado extensión",
        //   value: "statusExtension",
        //   class: "primary--text",
        //   width: "15%",
        // },
        // {
        //   text: "Duración",
        //   value: "duration",
        //   class: "primary--text",
        //   align: "center",
        //   width: "10%",
        // },
        // {
        //   text: "Estado agente",
        //   value: "status",
        //   class: "primary--text",
        //   width: "10%",
        // },
        // {
        //   text: "Tiempo de pausa",
        //   value: "pauseTime",
        //   class: "primary--text",
        //   width: "10%",
        // },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "left",
          sortable: false,
        },
        // {
        //   text: "Colas",
        //   value: "role.name",
        //   class: "primary--text",
        //   width: "15%"
        // },
      ],
      // DESBLOQUEAR AGENTE
      Agent: {},
      comment: "",
      showComment: false,
      // DESPAUSAR AGENTE
      pauseToDelete: null,
      isConfirmDialog: false,
      breaksList: [],
      newExtensionList: [],
      dates: {},
      agentSelectedId: null,
      agentHistory:[],
      fakeData: {
        current_page: 1,
        data: [
            {
                "id": 2033,
                "name": "Birzeyith Misselemith Maza Mendez",
                "email": "mazabriyith@gmail.com",
                "status": 1,
                "extension": "202",
                "variable": null,
                "extension_opcional": null,
                "logs": [
                    {
                        "id": 513337,
                        "action_type_id": 12,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 18:36:56",
                        "action": {
                            "id": 12,
                            "name": "Sale de cola",
                            "description": "El usuario sale de una cola de espera"
                        }
                    },
                    {
                        "id": 505823,
                        "action_type_id": 11,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-16 13:41:04",
                        "action": {
                            "id": 11,
                            "name": "Entra a cola",
                            "description": "El usuario entra a una cola de espera"
                        }
                    },
                    {
                        "id": 505931,
                        "action_type_id": 12,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-16 14:01:27",
                        "action": {
                            "id": 12,
                            "name": "Sale de cola",
                            "description": "El usuario sale de una cola de espera"
                        }
                    },
                    {
                        "id": 505932,
                        "action_type_id": 11,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-16 14:01:33",
                        "action": {
                            "id": 11,
                            "name": "Entra a cola",
                            "description": "El usuario entra a una cola de espera"
                        }
                    },
                    {
                        "id": 506105,
                        "action_type_id": 12,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-16 14:34:39",
                        "action": {
                            "id": 12,
                            "name": "Sale de cola",
                            "description": "El usuario sale de una cola de espera"
                        }
                    },
                    {
                        "id": 506107,
                        "action_type_id": 11,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-16 14:34:43",
                        "action": {
                            "id": 11,
                            "name": "Entra a cola",
                            "description": "El usuario entra a una cola de espera"
                        }
                    },
                    {
                        "id": 506180,
                        "action_type_id": 12,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-16 14:48:13",
                        "action": {
                            "id": 12,
                            "name": "Sale de cola",
                            "description": "El usuario sale de una cola de espera"
                        }
                    },
                    {
                        "id": 513200,
                        "action_type_id": 12,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 17:22:41",
                        "action": {
                            "id": 12,
                            "name": "Sale de cola",
                            "description": "El usuario sale de una cola de espera"
                        }
                    },
                    {
                        "id": 513214,
                        "action_type_id": 12,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 17:26:18",
                        "action": {
                            "id": 12,
                            "name": "Sale de cola",
                            "description": "El usuario sale de una cola de espera"
                        }
                    },
                    {
                        "id": 512253,
                        "action_type_id": 11,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 13:58:49",
                        "action": {
                            "id": 11,
                            "name": "Entra a cola",
                            "description": "El usuario entra a una cola de espera"
                        }
                    },
                    {
                        "id": 513322,
                        "action_type_id": 12,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 18:17:08",
                        "action": {
                            "id": 12,
                            "name": "Sale de cola",
                            "description": "El usuario sale de una cola de espera"
                        }
                    },
                    {
                        "id": 513201,
                        "action_type_id": 1,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 17:22:47",
                        "action": {
                            "id": 1,
                            "name": "Pausa",
                            "description": "El usuario inicia una pausa"
                        }
                    },
                    {
                        "id": 513209,
                        "action_type_id": 11,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 17:26:13",
                        "action": {
                            "id": 11,
                            "name": "Entra a cola",
                            "description": "El usuario entra a una cola de espera"
                        }
                    },
                    {
                        "id": 513210,
                        "action_type_id": 1,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 17:26:13",
                        "action": {
                            "id": 1,
                            "name": "Pausa",
                            "description": "El usuario inicia una pausa"
                        }
                    },
                    {
                        "id": 513215,
                        "action_type_id": 11,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 17:26:19",
                        "action": {
                            "id": 11,
                            "name": "Entra a cola",
                            "description": "El usuario entra a una cola de espera"
                        }
                    },
                    {
                        "id": 513323,
                        "action_type_id": 1,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 18:17:14",
                        "action": {
                            "id": 1,
                            "name": "Pausa",
                            "description": "El usuario inicia una pausa"
                        }
                    },
                    {
                        "id": 513335,
                        "action_type_id": 11,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 18:36:50",
                        "action": {
                            "id": 11,
                            "name": "Entra a cola",
                            "description": "El usuario entra a una cola de espera"
                        }
                    },
                    {
                        "id": 513336,
                        "action_type_id": 1,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 18:36:50",
                        "action": {
                            "id": 1,
                            "name": "Pausa",
                            "description": "El usuario inicia una pausa"
                        }
                    },
                    {
                        "id": 513338,
                        "action_type_id": 11,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 18:36:57",
                        "action": {
                            "id": 11,
                            "name": "Entra a cola",
                            "description": "El usuario entra a una cola de espera"
                        }
                    },
                    {
                        "id": 513393,
                        "action_type_id": 12,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 20:58:11",
                        "action": {
                            "id": 12,
                            "name": "Sale de cola",
                            "description": "El usuario sale de una cola de espera"
                        }
                    },
                    {
                        "id": 513394,
                        "action_type_id": 11,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 20:58:33",
                        "action": {
                            "id": 11,
                            "name": "Entra a cola",
                            "description": "El usuario entra a una cola de espera"
                        }
                    },
                    {
                        "id": 513403,
                        "action_type_id": 12,
                        "user_id": 2033,
                        "client_id": 44,
                        "created_at": "2024-12-18 21:35:54",
                        "action": {
                            "id": 12,
                            "name": "Sale de cola",
                            "description": "El usuario sale de una cola de espera"
                        }
                    }
                ],
                "daily": [
                    {
                        "id": 81746,
                        "user_id": 2033,
                        "hours_worked": "07:13:46",
                        "created_at": "2024-12-18 20:58:31",
                        "updated_at": "2024-12-18 21:35:55",
                        "check_in": "2024-12-18 13:58:47",
                        "check_in_date": "2024-12-18"
                    },
                    {
                        "id": 81427,
                        "user_id": 2033,
                        "hours_worked": "01:07:05",
                        "created_at": "2024-12-16 14:34:42",
                        "updated_at": "2024-12-16 14:48:14",
                        "check_in": "2024-12-16 13:41:02",
                        "check_in_date": "2024-12-16"
                    }
                ]
            }
        ],
        first_page_url: "https:\/\/c101.pbxberry.com:83\/api\/generate-report-user?page=1",
        from: 1,
        last_page: 1,
        last_page_url: "https:\/\/c101.pbxberry.com:83\/api\/generate-report-user?page=1",
        next_page_url: null,
        path: "https:\/\/c101.pbxberry.com:83\/api\/generate-report-user",
        per_page: 15,
        prev_page_url: null,
        to: 1,
        total: 1
    }

    };
  },

  watch: {
    options: {
      handler() {
        this.getAgents();
      },
      deep: true,
    },

    statusFilter() {
      this.getAgents();
      this.getNewExtensionList();
    },
  },

  computed: {
    breaks() {
      return this.$store.getters["breaks/GET_BREAK_LOCK"];
    },
  },

  async created() {
    await this.getBreaks();
    await this.getBreaks2();

    // this.interval = setInterval(() => {
    //   this.getNewExtensionList();
    // }, 30000);
  },

  mounted() {
    this.getNewExtensionList();
    this.getAgents();
  },

  // beforeDestroy() {
  //   clearInterval(this.interval);
  // },

  methods: {
    openRangeDialog(agentId, agentName){
      this.rangeDialogActive = true;
      this.agentSelectedId = agentId;
      this.agentSelectedName = agentName;
    },
    
    closedRangeDialog(){
      this.timelineDialog = false
      this.agentSelectedId = null;
      this.agentSelectedName = null;
    },

    getRangeDates(dates) {
      this.dates.date = dates[0];
      this.dates.dateEnd = dates[1];
    },

    getTimeTillNowFromItem(item) {
      const pauseUpdatedAt = item.user_pause[0]?.updated_at;
      if (!pauseUpdatedAt) return "--";
      return getTimeTillNow(pauseUpdatedAt);
    },

    reloadPage() {
      // window.location.reload();
      this.getAgents();
      this.getNewExtensionList();
    },

    statusColor(status) {
      let color;

      switch (status) {
        case 0:
          color = "error";

          break;

        case 1:
          color = "success";

          break;

        case 2:
          color = "light-blue";

          break;

        case 3:
          color = "warning";

          break;
      }
      return color;
    },

    typeAction(type) {
      let value;

      switch (type) {
        case 0:
          value = {
            small: true,
            icon: "",
            color: "success"
          };

          break;

        case 1:
          value = {
            small: false,
            icon: "mdi-coffee",
            color: "info"
          };

          break;

        case 2:
          value = {
            small: false,
            icon: "mdi-phone-incoming",
            color: "primary"
          };

          break;

        case 3:
          value = {
            small: false,
            icon: "mdi-phone-outgoing",
            color: "secondary"
          };

          break;

        case 4:
          value = {
            small: false,
            icon: "mdi-secondary",
            color: "secondary"
          };

          break;

        case 5:
          value = {
            small: false,
            icon: "mdi-tag",
            color: "amber"
          };

          break;

        case 6:
          value = {
            small: false,
            icon: "mdi-message-check",
            color: "teal"
          };

          break;

        case 7:
          value = {
            small: true,
            icon: "",
            color: "teal"
          };

          break;

        case 8:
          value = {
            small: true,
            icon: "",
            color: "teal"
          };

          break;

        case 9:
          value = {
            small: false,
            icon: "mdi-message-off",
            color: "teal"
          };

          break;

        case 10:
          value = {
            small: false,
            icon: "mdi-coffee-off",
            color: "pink"
          };

          break;

        case 11:
          value = {
            small: true,
            icon: "",
            color: "purple"
          };

          break;

        case 12:
          value = {
            small: true,
            icon: "",
            color: "purple"
          };

          break;

        case 13:
          value = {
            small: false,
            icon: "mdi-coffee",
            color: "info"
          };

          break;

        case 14:
          value = {
            small: true,
            icon: "",
            color: "indigo"
          };

          break;

        case 15:
          value = {
            small: false,
            icon: "mdi-list-box",
            color: "brown"
          };

          break;

        case 16:
          value = {
            small: false,
            icon: "mdi-calendar-clock",
            color: "light-green darken-3"
          };

          break;

        case 17:
          value = {
            small: true,
            icon: "",
            color: "error"
          };

          break;
      }
      return value;
    },

    dateFormat(date) {
      const dateFormatted = date
        .toString()
        .slice(0, 10)
        .split("-")
        .reverse()
        .join("/");
      return dateFormatted;
    },

    extensionState(agentExtension = null) {
      let item = null,
        status;
      // console.log(this.newExtensionList);
      const state = this.newExtensionList.filter((item) => item.ext == agentExtension);

      if (state.length > 0) item = state[0].status;

      switch (item) {
        case "Ring":
          status = "Ring";

          break;

        case "Up":
          status = "En llamada";

          break;

        default:
          status = "Libre";
      }
      // return item;

      return status;
    },

    async eventdialog(data) {
      this.rangeDialogActive = false;
      if (data !== "cerrar") {
        this.isLoading = true;
        try {
          const { data } = await PbxHttpClient.get(
            `/generate-report-user?start_date=${this.dates.date}&end_date=${this.dates.dateEnd}&user_id=${this.agentSelectedId}`
          );

          // const data = this.fakeData;

          if (data.data.length > 0 && data.data[0]?.logs !== undefined) {
            const loginObject = {
              action: {
                id: 0,
                name: "Inicio de sesión",
                description: "Entró al sistema.",
              },
            };
            const logoutObject = {
              action: {
                id: 17,
                name: "Cerró sesión",
                description: "El agente salió del sistema.",
              },
            };

            // Asignar logs existentes
            this.agentHistory = data.data[0].logs;

            // Crear logins y logouts basados en daily
            const dailyLogs = data.data[0].daily.flatMap((item) => [
              {
                created_at: item.check_in, // Usar check_in como created_at para login
                action_type_id: 0,
                action: loginObject.action,
                user_id: item.user_id,
              },
              {
                created_at: item.updated_at, // Usar updated_at como created_at para logout
                action_type_id: 17,
                action: logoutObject.action,
                user_id: item.user_id,
              },
            ]);

            // Combinar y ordenar los logs
            this.agentHistory = [...this.agentHistory, ...dailyLogs].sort(
              (a, b) => new Date(a.created_at) - new Date(b.created_at)
            );
          } else {
            this.agentHistory = [];
          }

          // Mostrar el diálogo de la línea de tiempo
          this.timelineDialog = true;
        } catch (err) {
          console.log("Error:", err);
        } finally {
          this.isLoading = false;
        }
      }
    },

    // async eventdialog(data) {
    //   this.rangeDialogActive = false;
    //   if (data !== "cerrar") {
    //     this.isLoading = true;
    //     try {
    //       const { data } = await PbxHttpClient.get(
    //         `/generate-report-user?start_date=${this.dates.date}&end_date=${this.dates.dateEnd}&user_id=${this.agentSelectedId}`,
    //       );

    //       if (data.data.length > 0 && data.data[0]?.logs !== undefined) {
    //         const loginObject = {
    //             action: {
    //                 id: 0,
    //                 name: 'Inicio de sesión',
    //                 description: 'Entró al sistema.'
    //             }
    //         };
    //         const logoutObject = {
    //             action: {
    //                 id: 17,
    //                 name: 'Cerró sesión',
    //                 description: 'El agente salió del sistema'
    //             }
    //         };

    //           this.agentHistory = data.data[0].logs;

    //           const logins = data.data[0].daily.map(item => ({
    //               ...item,
    //               action_type_id: 0,
    //               action: loginObject.action
    //           }));

    //           const logouts = data.data[0].daily.map(item => ({
    //               ...item,
    //               action_type_id: 17,
    //               action: logoutObject.action
    //           }));

    //          this.agentHistory = [...this.agentHistory, ...logins, ...logouts];

    //          this.agentHistory.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    //       } else {
    //           this.agentHistory = [];
    //       }
          
    //       this.timelineDialog = true;
    //     } catch (err) {
    //       console.log(err);
    //     }
    //     this.isLoading = false;
    //   } 
    //   return;
    // },

    async getNewExtensionList() {
      try {
        const { data } = await PbxHttpClient.get(`/manager/extension_new`);
        this.newExtensionList = data.data;
      } catch (err) {
        this.$snotify.error("Hubo un error consultando las extensiones.", "¡Error!");
      }
    },

    findDurationByExt(extension) {
      const matchingItem2 = this.newExtensionList.find((item) => item.ext === extension);
      if (matchingItem2) {
        if (matchingItem2.duration) {
          return matchingItem2.duration + "s";
        }
      }

      return "--"; // Si no se encuentra ninguna coincidencia
    },

    // DESBLOQUEAR AGENTE
    UnlockAgent(item) {
      this.showComment = true;
      this.Agent = item;
    },

    async unlockConfirm() {
      const enviar = {
        comment: {
          comment: this.comment,
        },
        id: this.Agent,
      };
      const response = await this.$store.dispatch("breaks/UNLOCK_AGENTS", enviar);
      this.showComment = false;
      alert(response.data.message);

      this.reloadPage();
    },
    //

    // QUITAR PAUSA AGENTE
    openConfirmClose(pauseId) {
      this.pauseToDelete = pauseId;
      this.isConfirmDialog = true;
    },

    async getBreaks2() {
      try {
        const response = await this.$store.dispatch("breaks/SHOW_AGENTS_BREAKS_LOCK");
        // console.log(response);
      } catch (error) {
        console.log(error);
      }
    },

    async getBreaks() {
      try {
        const { data } = await PbxHttpClient.get("/agent/use_pause/");
        // console.log("agents", data.data);
        this.breaksList = data.data;
      } catch (error) {
        this.$snotify.error("Hubo un error en la consulta", "Error");
        // console.log(error);
      }
      this.isLoadingTable = false;
    },

    async closePause() {
      this.isLoading = true;
      try {
        await PbxHttpClient.put(`/agent/use_pause/${this.pauseToDelete}`);
        this.breaksList = this.breaksList.filter(
          (e) => e.pause_id !== this.pauseToDelete
        );
        this.pauseToDelete = null;
        this.$snotify.success("Pausa cerrada con éxito.", "¡Hecho!");
        this.isConfirmDialog = false;
        this.reloadPage();
      } catch (err) {
        this.$snotify.error("Hubo un error cerrando la pausa", "Error");
      }

      this.isLoading = false;
    },
    //

    /**
     * Busca la lista de agentes
     *
     * @param {Number} page - Numero de pagina a mostrar
     */
    getAgents() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });
      this.isLoading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const accessToken = localStorage.getItem("token");

      axios
        .get(
          `${process.env.VUE_APP_ROOTAPI}/clients/show/agents?page=${page}&itemPerPage=${itemsPerPage}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
        .then((res) => {
          this.agentInfo = res.data.data;
          this.agentInfoBackup = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
          this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
        });
    },

    async getNewExtensionList() {
      try {
        const { data } = await PbxHttpClient.get(`/manager/extension_new`);
        this.newExtensionList = data.data;
      } catch (err) {
        this.$snotify.error("Hubo un error consultando las extensiones.", "¡Error!");
      }
    },

    async changeStatus(value) {
      // console.log("Prueba", value);
      const conf = confirm("CAMBIAR ESTATUS");
      if (conf) {
        try {
          if (value.status === 2) {
            await this.$store.dispatch("user/QUIT_PAUSE", {
              id: value.user_pause[0].id,
            });
          } else {
            await this.$store.dispatch("user/CHANGE_STATUS", {
              id: value.id,
            });
          }

          this.$snotify.success("Estatus cambiado con éxito.", "¡Hecho!");

          this.getAgents();
        } catch (error) {
          this.$snotify.error("No se pudo cambiar el estado del usuario.", "¡Error!");
          // console.error(error);
        }
      }
    },

    handleEdit(user) {
      if (user.connect === 1) {
        this.$snotify.warning("No se puede editar un usuario conectado.", "Espera");
      } else {
        this.editUser = {
          id: user.id,
          name: user.name,
          email: user.email,
          extension: user.extension,
          variable: user.variable,
          queues: user.queues,
          priority_order: user.priority_order,
          // password: user.password,
          role_id: user.role_id,
          auto_connection: user.auto_connection,
          extension_opcional: user.extension_opcional,
        };
        this.active = true;
      }
    },

    async handleLogoutPlanta(id, name) {
      const accessToken = localStorage.getItem("token");

      const confirmRequest = await this.$swalconfirm(
        "Logout",
        `Está seguro de cerrar sesión a ${name}.`
      );

      if (confirmRequest.isConfirmed) {
        axios
          .get(`${process.env.VUE_APP_ROOTAPI}/authServer/desconnect/${id}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              for (const client of res.data) {
                switch (client.codigo) {
                  case "Command":
                    this.$snotify.error(
                      `Cola ${client.queue}: ${client.message}`,
                      "¡Error!"
                    );

                    break;

                  case "Removed":
                    this.$store.commit("passport/UPDATE_CONNECTION_AGENT", 0);

                    this.$snotify.success(`${client.message}`, `Cola ${client.queue}`);

                    break;
                }
              }
              this.getAgents();
            }
          })
          .catch((error) => {
            // console.error(error);
            this.$snotify.error("No se pudo desconectar de la planta.", "Error");
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },

    async handleLogoutSystem(id) {
      const accessToken = localStorage.getItem("token");
      axios
        .post(`${process.env.VUE_APP_ROOTAPI}/assistance/logoutAdmin/${id}`, "", {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          this.getAgents();
          this.$snotify.success("Sesión finalizada.", "¡Hecho!");
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("No se pudo cerrar sesión de este usuario.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
